import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { loadData } from "../../../store/actions/dashactions";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

import moment from 'moment';




function Home(props) {




  useEffect(()=>{
    handleSubmit();
  },[])

  const [sumdata, setSumdata] = useState([]);
  
    const [selFY, setSelectedFY] = useState('')

const currentYear = new Date().getFullYear();
const startYear = 2024;

const options = Array.from({ length: currentYear - startYear + 6 }, (_, i) => {
  const year = startYear + i;
  return {
    value: year,
    label: `FY ${year.toString().slice(-2)}`
  };
});

    const handleSubmit = (event) => {
        if (event) event.preventDefault(); // only call preventDefault if triggered by form
        const leasetype = event?.target?.leasetype?.value || "In-Lease";
        const fyyear = parseInt(event?.target?.fyyear?.value || currentYear); // e.g. 2024 for FY 2024 (July 2024 – June 2025)

         // FY period
            const fyStart = `${fyyear-1}-07-01`;
            const fyEnd = `${fyyear}-06-30`;

        axios.post(`${API_BASE_URL}api/leasegeneralreport`, {
            leasetype,fyStart,fyEnd
        })
            .then((response) => {
            const allLeases = response.data;
            console.log(allLeases);
            const result = getTotalFYBaseRent(allLeases, fyyear);

            setSumdata(result); // only leases active in that FY
            // setltype(`(${leasetype})`);
            setSelectedFY(fyyear); // optional: store current FY
            // setReport(`FY ${fyyear.toString().slice(-2)}`)
            })
            .catch((error) => {
            console.log(error);
            });
        };
    const getTotalFYBaseRent = (leases, targetFY) => {
        let totalAnnualRentBase = 0;
        let totalMonthlyBaseRent = 0;
        // Step 2: Get unique leasecode count
        const uniqueLeaseCodes = new Set(leases.map(l => l.leasecode));
        const totalLeaseCount = uniqueLeaseCodes.size;
        let activeLeaseCount = 0;
        let totalSqftOccupied = 0;
        let subleaseCount = 0;
        let newLeaseCount = 0;
        let terminatedLeaseCount = 0;
        let expiringWithin6Months = 0;

        const fyStart = moment(`${targetFY - 1}-07-01`);
        const fyEnd = moment(`${targetFY}-06-30`);
        const today = moment();
        const sixMonthsFromToday = today.clone().add(6, 'months');        

        const countedLeaseCodes = new Set(); //  Track counted leases

        leases.forEach((lease) => {
            const leaseStart = moment(lease.commence_date);
            const leaseEnd = moment(lease.expiration_date);
            const terminatedDate = lease.leasterminateddate ? moment(lease.leasterminateddate) : null;

            const isActiveInFY = leaseStart.isSameOrBefore(fyEnd) && leaseEnd.isSameOrAfter(fyStart);
            const isNewLeaseInFY = leaseStart.isBetween(fyStart, fyEnd, null, '[]');
            const isTerminatedInFY = lease.leaseterminatedflag === 'Y' && terminatedDate && terminatedDate.isSameOrBefore(fyEnd);
            const isExpiringSoon = leaseEnd.isSameOrBefore(sixMonthsFromToday) && leaseEnd.isAfter(today);

            if (lease.subleaseflag === 'Y') subleaseCount++;
            if (isNewLeaseInFY) newLeaseCount++;
            if (isTerminatedInFY) terminatedLeaseCount++;
            if (isExpiringSoon) expiringWithin6Months++;
            
            totalSqftOccupied += lease.areasf ?? 0;

            

            const fyValues = getFYBaseRentValues(targetFY, lease);
            const monthlyBase1 = fyValues.monthlyBase1 ?? 0;
            const monthlyBase2 = fyValues.monthlyBase2 ?? 0;
            const months1 = fyValues.months1 ?? 0;
            const months2 = fyValues.months2 ?? 0;
            const monthlyOther = lease.monthlyrentother ?? 0;
            const monthlyCam = lease.monthlyrentcam ?? 0;

            totalMonthlyBaseRent += monthlyBase1 + monthlyBase2 + monthlyOther + monthlyCam;
            totalAnnualRentBase += (monthlyBase1 * months1) + (monthlyBase2 * months2)+ (monthlyOther * (months1 + months2))+ (monthlyCam * (months1 + months2));

            if (!isActiveInFY) return;

            // activeLeaseCount++;
            // Count only unique lease codes for active leases
            if (isActiveInFY && !countedLeaseCodes.has(lease.leasecode)) {
                countedLeaseCodes.add(lease.leasecode);
                activeLeaseCount++;
            }
        });

        return {
            totalAnnualRentBase: parseFloat(totalAnnualRentBase.toFixed(2)),
            totalMonthlyBaseRent: parseFloat(totalMonthlyBaseRent.toFixed(2)),
            totalLeaseCount,
            activeLeaseCount,
            totalSqftOccupied,
            subleaseCount,
            newLeaseCount,
            terminatedLeaseCount,
            expiringWithin6Months
        };
        };
    
        const getFYBaseRentValues = (targetFY, infoDetail) => {
            const basePSF = infoDetail.rentpersf ?? 0;
            const sqft = infoDetail.fsqft ?? infoDetail.areasf ?? 0;
            const escalationPercent = infoDetail.escalationpercent ?? 0;
    
            const commence = moment(infoDetail.rental_commence_date || infoDetail.commence_date);
            
            // Use leasterminateddate if it exists and is earlier than expiration_date
            let expire = moment(infoDetail.expiration_date);
            if (infoDetail.leasterminateddate && moment(infoDetail.leasterminateddate).isBefore(expire)) {
                expire = moment(infoDetail.leasterminateddate);
            }
    
            const currentStart =  commence.clone();
    
            const stopDates = (infoDetail.internal_stop_dates ?? []).map(date => moment(date)).sort((a, b) => a - b);
    
            let psf = basePSF;
            let start = currentStart.clone();
    
            const fyStart = moment.utc(`${targetFY-1}-07-01`);
            const fyEnd = moment.utc(`${targetFY}-06-30`);
    
            const results = [];
    
            while (start.isSameOrBefore(expire)) {
                let end = start.clone().add(1, 'year').subtract(1, 'day');
    
                const stop = stopDates.find(d => d.isSameOrAfter(start) && d.isSameOrBefore(end));
                if (stop) end = stop.clone();
    
                if (end.isAfter(expire)) end = expire.clone();
    
                const overlapStart = moment.max(start, fyStart);
                const overlapEnd = moment.min(end, fyEnd);
    
                if (overlapStart.isSameOrBefore(overlapEnd)) {
                    const months = overlapEnd.diff(overlapStart, 'months') + 1;
                    const monthlyBase = parseFloat(((psf * sqft) / 12).toFixed(2));
    
                    results.push({
                        months,
                        psf: parseFloat((Math.floor(psf * 100) / 100).toFixed(2)),
                        monthlyBase
                    });
                }
    
                const isFullYear = end.diff(start, 'months') >= 11;
                const wasStoppedEarly = stop && stop.isSame(end);
                if (isFullYear || wasStoppedEarly) {
                    psf *= 1 + escalationPercent / 100;
                }
    
                start = end.clone().add(1, 'day');
                if (start.isAfter(expire)) break;
            }
    
            // Rename keys for output: psf1, psf2, etc.
            const final = {};
            results.forEach((item, index) => {
                const suffix = index + 1;
                final[`months${suffix}`] = item.months;
                final[`psf${suffix}`] = item.psf;
                final[`monthlyBase${suffix}`] = item.monthlyBase;
            });
            
            if (final.months1 && final.months2 && (final.months1 + final.months2 > 12)) {
                final.months2 = final.months2 - 1;
            }
    
            return final;
        };
  return (
    <>
    <div className="row mb-4 ml-1">
      <div className="col-md-8">
        <div className="report-card" >
          <div className="report-label" >Total Leases</div>
          <div className="report-value box" >{(sumdata.totalLeaseCount ||0)}</div>
        </div>
        <div className="report-card" >
          <div className="report-label" >Total Active Leases</div>
          <div className="report-value box" >{(sumdata.activeLeaseCount-sumdata.terminatedLeaseCount ||0)}</div>
        </div>
        <div className="report-card">
          <div className="report-label">Total Revenue (Annual Lease Cost )</div>
          <div className="report-value">${(sumdata.totalAnnualRentBase ||0).toLocaleString()}</div>
        </div>
        <div className="report-card">
          <div className="report-label">Monthly Lease Cost</div>
          <div className="report-value">${(sumdata.totalMonthlyBaseRent ||0).toLocaleString()}</div>
        </div>
        <div className="report-card">
          <div className="report-label">Sqft Occupied</div>
          <div className="report-value">{(sumdata.totalSqftOccupied ||0).toLocaleString()}</div>
        </div>
        <div className="report-card">
          <div className="report-label ">No.of Subleases</div>
          <div className="report-value box">{(sumdata.subleaseCount ||0).toLocaleString()}</div>
        </div>
        <div className="report-card">
          <div className="report-label">No.of New Leases</div>
          <div className="report-value box">{(sumdata.newLeaseCount ||0).toLocaleString()}</div>
        </div>
        <div className="report-card">
          <div className="report-label">Terminated Leases</div>
          <div className="report-value box">{(sumdata.terminatedLeaseCount ||0).toLocaleString()}</div>
        </div>
        
        <div className="report-card">
          <div className="report-label">Exp. Leases W/in 6 mos.</div>
          <div className="report-value box"  style={{background:'#C42929'}}>{(sumdata.expiringWithin6Months ||0).toLocaleString()}</div>
        </div>
      </div>
      <div className="col-md-4">
      <form onSubmit={handleSubmit}  className="dash-form">
              <div className="form-row" style={{alignItems:'flex-end'}}>
                  <div className="form-group col-md-12">
                    <select className="form-control" defaultValue={"In-Lease"} id="leasetype"   name="leasetype">
                    <option value={"In-Lease"} >In-Lease</option>
                                              <option value={"Out-Lease"} >Out-Lease</option>
                                              <option value={"Licence"}>Licence</option>
                    </select>
                  </div>
                  <div className="form-group col-md-12">
                    
                    <select className="form-control" defaultValue={currentYear}  id="fyyear" name="fyyear" >
                      {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group col-md-12 mt-3">
                    <button type="submit"   className="btn btn-primary btn-apl">Apply</button>
                  </div>
                </div>
              </form>

      </div>

    </div>

      
    </>
  );
}

const mapStateToProps = (state) =>
{ 
  return {
  lease: state.HomeReducer.lease,
  surplus: state.HomeReducer.surplus
  }
};

const mapDispatchToProps  = {
  loadData: (leasetype) => loadData(leasetype)
}

export default connect(mapStateToProps, mapDispatchToProps) (Home);
